"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operation = void 0;
var Operation;
(function (Operation) {
    Operation[Operation["Show"] = 1] = "Show";
    Operation[Operation["Hide"] = 2] = "Hide";
    Operation[Operation["Required"] = 3] = "Required";
    Operation[Operation["Optional"] = 4] = "Optional";
})(Operation = exports.Operation || (exports.Operation = {}));
//# sourceMappingURL=rule.js.map